import type {
  GraphQLBook,
  GraphQLSearchResult,
  RestSearchBook,
  RestSearchResponse
} from './types'

function mapBook(book: RestSearchBook): GraphQLBook {
  return {
    __typename: 'Book',
    name: book.name ?? null,
    slug: book.slug ?? null,
    author: book.author ?? null,
    degree: book.degree ?? null,
    hasAudioBook: book.has_audio_book ?? null,
    hasEbook: book.has_ebook ?? null,
    isReadingTrail: book.is_reading_trail ?? null,
    language: book.language ?? null,
    imageUrlThumb: book.image_url_thumb ?? null,
    imageUrlThumbLow: book.image_url_thumb_low ?? null,
    imageUrlIntermediaria: book.image_url_intermediaria ?? null,
    publisher: book.publisher
      ? {
          __typename: 'BookPublisher',
          id: book.publisher.id,
          name: book.publisher.name
        }
      : null,
    layout: book.layout ?? null,
    manualInfoChecked: book.manual_info_checked ?? null,
    image: book.image ?? null,
    v2ready: book.v2ready ?? null,
    maxUses: book.max_uses ?? null,
    bookwire: book.bookwire ?? null,
    description: book.description ?? null,
    subtitle: book.subtitle ?? null,
    freemium: book.freemium ?? null,
    price: book.price ?? null,
    englishLevel: book.english_level ?? null,
    lexileLevel: book.lexile_level ?? null,
    themas: book.themas ?? null
  }
}

export function mapRestToGraphQL(
  rest: RestSearchResponse
): GraphQLSearchResult {
  return {
    __typename: 'SearchResult',
    books: rest.books.map(mapBook),
    searchFilters: rest.search_filters
  }
}
